import { render, staticRenderFns } from "./NationalTrademarkList.vue?vue&type=template&id=9575a5aa&"
import script from "./NationalTrademarkList.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkList.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkList.vue?vue&type=style&index=0&id=9575a5aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports